import React from 'react';
export function ScandiLogos() {
  return <div className="min-h-screen bg-[#fafaf8] py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-637">
      <div className="max-w-7xl mx-auto" data-id="element-638">
        <div className="text-center mb-16" data-id="element-639">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-640">
            Scandinavian Wordmarks
          </h1>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto" data-id="element-641">
            Subtle, restrained typography with quiet Nordic influence — clean
            lines, generous space, and purposeful simplicity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-642">
          {/* 1. Clean Wide */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-643">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-644">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-645">
                1. Clean Wide
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-646">
                Light / Wide tracking / Navy
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-647">
              <div className="flex items-center" data-id="element-648">
                <span className="text-xl font-light text-[#0f2546] tracking-[0.25em] uppercase" data-id="element-649">
                  Swedenmark
                </span>
                <span className="text-xl font-medium text-[#005293] tracking-[0.25em] uppercase ml-3" data-id="element-650">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 2. Warm Gray */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-651">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-652">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-653">
                2. Warm Gray
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-654">
                Lowercase / Warm / Gold dot
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-[#fafaf8]" data-id="element-655">
              <div className="flex items-baseline" data-id="element-656">
                <span className="text-2xl font-normal text-[#4a4a4a] tracking-tight" data-id="element-657">
                  swedenmark ai
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-[#c8a84e] ml-1.5" data-id="element-658"></div>
              </div>
            </div>
          </div>

          {/* 3. Swedish Blue */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-659">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-660">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-661">
                3. Swedish Blue
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-662">
                Bold / Blue accent / Clean
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-663">
              <div className="flex items-baseline" data-id="element-664">
                <span className="text-2xl font-semibold text-[#0f2546] tracking-tight" data-id="element-665">
                  Swedenmark
                </span>
                <span className="text-2xl font-semibold text-[#005293] ml-2" data-id="element-666">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 4. Thin Bar */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-667">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-668">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-669">
                4. Thin Bar
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-670">
                Light / Bar separator / Airy
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-671">
              <div className="flex items-center" data-id="element-672">
                <span className="text-xl font-light text-[#3a3a3a] tracking-wide lowercase" data-id="element-673">
                  swedenmark
                </span>
                <span className="text-xl font-extralight text-slate-300 mx-3" data-id="element-674">
                  |
                </span>
                <span className="text-xl font-light text-[#3a3a3a] tracking-wide lowercase" data-id="element-675">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 5. Stacked Minimal */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-676">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-677">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-678">
                5. Stacked Minimal
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-679">
                Stacked / Centered / Quiet
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-680">
              <div className="flex flex-col items-center leading-tight" data-id="element-681">
                <span className="text-xs font-medium text-slate-400 tracking-[0.4em] uppercase" data-id="element-682">
                  Swedenmark
                </span>
                <span className="text-3xl font-bold text-[#0f2546] tracking-tight mt-1" data-id="element-683">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 6. Gold Accent */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-684">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-685">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-686">
                6. Gold Accent
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-687">
                Domain / Gold dot / Understated
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-688">
              <div className="flex items-baseline" data-id="element-689">
                <span className="text-2xl font-medium text-[#0f2546] tracking-tight lowercase" data-id="element-690">
                  swedenmark
                </span>
                <span className="text-2xl font-medium text-[#c8a84e] lowercase" data-id="element-691">
                  .ai
                </span>
              </div>
            </div>
          </div>

          {/* 7. Diacritical Nod */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-692">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-693">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-694">
                7. Diacritical Nod
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-695">
                Swedish ä / Subtle cultural nod
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-696">
              <div className="flex items-baseline" data-id="element-697">
                <span className="text-2xl font-bold text-slate-800 tracking-tight lowercase" data-id="element-698">
                  swedenmärk
                </span>
                <span className="text-2xl font-light text-slate-400 ml-1 lowercase" data-id="element-699">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 8. Geometric Even */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-700">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-701">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-702">
                8. Geometric Even
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-703">
                Uppercase / Even spacing / Balanced
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-704">
              <span className="text-lg font-medium text-[#0f2546] tracking-[0.15em] uppercase" data-id="element-705">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 9. Two-Weight */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-706">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-707">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-708">
                9. Two-Weight
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-709">
                Light + Bold / Contrast within
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-710">
              <div className="flex items-baseline" data-id="element-711">
                <span className="text-2xl font-light text-[#0f2546] tracking-tight lowercase" data-id="element-712">
                  sweden
                </span>
                <span className="text-2xl font-bold text-[#0f2546] tracking-tight lowercase" data-id="element-713">
                  mark
                </span>
                <span className="text-2xl font-light text-[#0f2546] tracking-tight lowercase ml-1" data-id="element-714">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 10. Underscore */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-715">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-716">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-717">
                10. Underscore
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-718">
                Tech / Functional / Nordic restraint
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-719">
              <span className="text-xl font-medium text-[#2a2a2a] tracking-tight lowercase font-mono" data-id="element-720">
                swedenmark_ai
              </span>
            </div>
          </div>

          {/* 11. Spaced Caps */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-721">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-722">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-723">
                11. Spaced Caps
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-724">
                Ultra-wide / Whisper weight
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-725">
              <span className="text-sm font-light text-slate-600 tracking-[0.5em] uppercase" data-id="element-726">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 12. Warm Minimal */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-727">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-728">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-729">
                12. Warm Minimal
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-730">
                Medium / Warm tone / Approachable
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-[#faf9f6]" data-id="element-731">
              <div className="flex items-baseline" data-id="element-732">
                <span className="text-2xl font-medium text-[#3d3529] tracking-tight" data-id="element-733">
                  Swedenmark
                </span>
                <span className="text-2xl font-medium text-[#7a6f5d] ml-2" data-id="element-734">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}